import Alpine from 'alpinejs';
import Swiper from 'swiper';
import { Navigation, Keyboard, Pagination, Autoplay } from 'swiper/modules';
import { SwiperOptions } from 'swiper/types';

import './index.pcss';
import 'swiper/swiper.css';
import 'swiper/css/pagination';

document.addEventListener('alpine:init', () => {
    Alpine.data('initVerticalSteps', () => {
        return {
            shown: false,
            swiper: null as Swiper | null,
            sliderPause: false,
            start() {
                if (!this.shown) {
                    this.shown = true;
                    // eslint-disable-next-line @typescript-eslint/no-this-alias
                    const self = this;

                    const swiperParams: SwiperOptions = {
                        modules: [Navigation, Keyboard, Pagination, Autoplay],
                        init: false,
                        spaceBetween: 16,
                        slidesPerView: 1,
                        loop: true,
                        keyboard: {
                            enabled: true,
                        },
                        autoplay: {
                            delay: 4000,
                            pauseOnMouseEnter: true,
                            disableOnInteraction: false,
                        },
                        pagination: {
                            clickable: true,
                            el: this.$refs.pagination,
                            type: 'bullets',
                            bulletClass: 'swiper-bullet',
                            bulletActiveClass: 'is-active',
                            renderBullet: function (
                                index: number,
                                className: string,
                            ) {
                                const stepTitle = self.$el.querySelector(`.stepTitle${index + 1}`);
                                const stepContent = self.$el.querySelector(`.stepContent${index + 1}`);
                                className += ' flex-1 cursor-pointer max-lg:py-2 lg:flex lg:gap-6 xl:new-version:!gap-3 new-version:!flex-initial xl:gap-10';
                                return (
                                    '<div class="' +
                                    className +
                                    '">' +
                                    ' <div class="bullet-progress">' +
                                    '<div class="bullet-progress-inner"></div>' +
                                    '</div>' +
                                    '<div class="flex flex-col text-secondary-01-light is-active:text-black new-version:!text-black transition-colors max-lg:hidden">' +
                                    (stepTitle ? stepTitle.outerHTML : '') +
                                    (stepContent ? stepContent.outerHTML : '') +
                                    '</div>' +
                                    '</div>'
                                );
                            },
                        },
                    };

                    const swiper = new Swiper(
                        this.$refs.swiperContainer,
                        swiperParams,
                    );
                    this.swiper = swiper;

                    this.$nextTick(() => {
                        swiper.init();
                        //this.swiper.autoplay.stop();
                        this.linkClick()
                    });

                    this.$watch('shown', () => {
                        if (this.shown) {
                            this.swiper?.autoplay.start();
                        } else {
                            //this.swiper.autoplay.stop();
                        }
                    });
                }

            },
            pauseSlider () {
                if (this.sliderPause == false) {
                    this.sliderPause = true;
                    this.swiper?.autoplay.stop();
                } else {
                    this.sliderPause = false;
                    this.swiper?.autoplay.start();
                }
            },
            linkClick () {
                this.$el.querySelectorAll('.swiper-bullet').forEach((bullet: any) => {
                    bullet.addEventListener('click', (item: any) => {
                        if (item.srcElement.localName == 'a') {
                            location.href = item.srcElement.href
                        }
                    })
                })
            }
        };
    });
});
